<template>
    <div>
        <Accordion :activeIndex="0">
            <AccordionTab header="Use as many or few filters as you wish.">
                <!-- All the criterias here -->
                <div class="p-fluid formgrid grid">
                    <div class="field col-6 md:col-3">
                        <label for="code">Attribute Code:</label>
                        <InputText id="code" v-model.trim="params.code" placeholder="Input attribute code" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="sharedCompany">Shared/Company:</label>
                        <Dropdown inputId="sharedCompany" v-model="params.shared" :options="getSharedTypes()" placeholder="Select an attribute type" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="status">Status:</label>
                        <Dropdown inputId="status" v-model="params.default" :options="getDefaultTypes()" optionLabel="name" optionValue="value" placeholder="Select attribute status" :showClear="true" />
                    </div>

                    <div class="field col-6 md:col-3">
                        <label for="type">Attribute Type:</label>
                        <Dropdown inputId="type" v-model="params.user_profile" :options="getUserProfileTypes()" optionLabel="name" optionValue="value" placeholder="Select attribute type" :showClear="true" />
                    </div>

                    <div class="formgrid grid col-8">
                        <div class="field col-6 md:col-3">
                            <Button label="Reset Filters" icon="pi pi-refresh" @click="clearCriteria" />
                        </div>
                    </div>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import { watch, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { getSharedTypes } from '../../../constants';
import { getUserProfileTypes, getDefaultTypes } from '../constants';
import { attributeStore } from '@/store/global-stores';

const { params } = storeToRefs(attributeStore);

watch(params.value, () => {
    loadAttributes();
});

const loadAttributes = async () => {
    await attributeStore.fetchAllAttributes();
};

const clearCriteria = async () => {
    attributeStore.clearFilters();
};

onUnmounted(() => {
    clearCriteria();
});
</script>
